<div class="container-fluid">
  <div class="row">
    <div class="col-md-8 m-auto">
      <div class="card">
        <div class="card-header card-header-danger">
          <h4 class="card-title">{{ selectedCatId === 0 ? 'Add' : 'Edit' }} Category</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="categoryForm">
            <!-- Category Type Selection -->
            <div class="row">
              <div class="col-md-12">
                <mat-label>Category Type *</mat-label>
                <mat-radio-group
                  class="category-type-radio-group"
                  [value]="categoryType()"
                  (change)="onCategoryTypeChange($event.value)"
                >
                  <mat-radio-button value="category">Category</mat-radio-button>
                  <mat-radio-button value="sub-category">Sub-Category</mat-radio-button>
                  <mat-radio-button value="sub-sub-category">Sub-Sub-Category</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <!-- Main Category Selection (for sub-category and sub-sub-category) -->
            @if (categoryType() === 'sub-category' || categoryType() === 'sub-sub-category') {
              <div class="row w-full mt-3">
                <fh-form-autocomplete
                  [options]="mainCategoryOptions()"
                  label="Main Category"
                  placeholder="Select main category"
                  formControlName="main_category_id"
                  [required]="true"
                  (selectionChange)="onMainCategoryChange($event)"
                />
              </div>
            }

            <!-- Sub-Category Selection (only for sub-sub-category) -->
            @if (categoryType() === 'sub-sub-category') {
              <div class="row w-full mt-3">
                <fh-form-autocomplete
                  [options]="subCategoryOptions()"
                  label="Sub-Category"
                  placeholder="Select sub-category"
                  formControlName="sub_category_id"
                  [required]="true"
                />
              </div>
            }

            <!-- Category Name -->
            <div class="row mt-3">
              <mat-form-field class="col-md-12">
                <mat-label>Category Name</mat-label>
                <input
                  matInput
                  placeholder="Enter category name"
                  formControlName="category_name"
                  required
                />
                @if (isSubmitted && category_name?.['invalid']) {
                  <mat-error>This field is required.</mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Is Featured -->
            <div class="row w-full">
              <fh-form-autocomplete
                [options]="isFeaturedOptions"
                label="Is Featured"
                formControlName="is_featured"
                [required]="true"
              />
              @if (is_featured_err_msg) {
                <mat-hint>
                  <span class="text-danger">
                    <img src="../../../assets/images/info-icon-red.svg" alt="" class="info" />
                    {{ is_featured_err_msg }}
                  </span>
                </mat-hint>
              }
            </div>

            <!-- Image Display -->
            @if (image_submit ) {
              <div class="col-md-12 mt-3">
                <div class="form-group">
                  <mat-label>Current Image</mat-label>
                  <br />
                  @if (categoryImageBase64) {
                    <img [src]="categoryImageBase64" alt="Category Image" style="max-width: 200px; max-height: 200px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px; padding: 5px;" />
                  } @else {
                    <img
                    fhImageUrl="" [originalUrl]="category_img_url"
                      alt="Category Image"
                      style="max-width: 200px; max-height: 200px; object-fit: contain; border: 1px solid #ddd; border-radius: 4px; padding: 5px;"
                    />
                  }
                  @if (image_err_msg) {
                    <br />
                    <span class="text-danger">{{ image_err_msg }}</span>
                  }
                </div>
              </div>
            }

            <!-- Image Upload -->
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="form-group">
                  @if (successUpload) {
                    <div class="alert alert-success">
                      {{ successUpload }}
                    </div>
                  } @else if (errorUpload) {
                    <div class="alert alert-danger">
                      {{ errorUpload }}
                    </div>
                  }
                  <mat-label>Image Upload</mat-label>
                  <br />
                  <input
                    type="file"
                    #fileInput
                    name="category_img"
                    (change)="uploadCategoryPicture(fileInput)"
                    accept="image/png, image/jpeg, image/jpg"
                  />
                  @if (image_err_msg) {
                    <br />
                    <span class="text-danger">{{ image_err_msg }}</span>
                  }
                </div>
              </div>
            </div>

            <!-- Error/Success Messages -->
            <div class="row mt-3">
              <div class="col-md-12">
                @if (success) {
                  <div class="alert alert-success">
                    {{ success }}
                  </div>
                } @else if (error) {
                  <div class="alert alert-danger">
                    {{ error }}
                  </div>
                }
              </div>
            </div>

            <!-- Submit Button -->
            <div class="row mt-3">
              <div class="col-md-12">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  (click)="save()"
                  [disabled]="button_disabled"
                >
                  @if (selectedCatId === 0) {
                    Create Category
                  } @else {
                    Update Category
                  }
                </button>
                <button
                  mat-raised-button
                  type="button"
                  class="ml-2"
                  (click)="router.navigate(['/categories'])"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
